module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_front"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Captain P. J. D. McCraith who raised the Yeomanry Patrol in the Long Range Desert Group in front of his Ford truck. (HU 71713)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Bagnold Sun Compass. (HU 71822)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Captain David Lloyd Owen with ‘Tich’ Cave on the back of a 30-cwt truck outside the Farouk Hotel in Siwa oasis, November 1941. (HU 25299)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("A posed photograph of an LRDG Chevrolet truck. (E 12380)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("LRDG Chevrolet truck shooting a dune. The truck behind is a Ford 30-cwt. (HU 25793)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Lieutenant-Colonel John Haselden dressed as an Arab coming out of the desert to meet an LRDG patrol. (HU 24997)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("LRDG "), _c('span', {
    attrs: {
      "href": "#/xhtml/35_Glossary#gloss79",
      "id": "rgloss79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WACO")]), _vm._v(" aircraft. (HU 25081)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Y Patrol returning to Kufra after a successful incursion into enemy territory. (HU 25277)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("David Stirling with men of G Patrol of the LRDG. (HU 69650)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("An SAS jeep, heavily loaded with jerricans of fuel and water. (NA 676)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Lieutenant-Colonel Blair ‘Paddy’ Mayne. (AP 6069)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Field Marshal Sir Archibald Wavell, then C-in-C India, talking to a Chindit officer. (IND 2088)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Major-General Orde Wingate taken just before his death. (HU 71286)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Wingate in sun helmet with Colonel Frank Merill of Merill’s Marauders, and Lieutenant-Colonel Scott. (MH 7864)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Wingate briefing aircrew of Number 1 Air Commando USAAF. (MH 7877)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("A mule being loaded into a "), _c('span', {
    attrs: {
      "href": "#/xhtml/35_Glossary#gloss14",
      "id": "rgloss14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dakota")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/35_Glossary#gloss13",
      "id": "rgloss13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C-47")]), _vm._v(". (EA 20831)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("A sick man being loaded into an L-5 light aircraft in Burma. (SF 7947)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Two British soldiers and a Gurkha being evacuated from Burma. (HU 67284)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Chindits of 54 Column, 16th Infantry Brigade, carrying a wounded man on a stretcher. (KY 481781)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("L-5 on an airstrip in Burma. (SE 7936)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Chindits on the march in Burma. (SF 7929)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Chindits brewing up. (IND 2289)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Brigadier Mike Calvert giving orders to Lieutenant-Colonel Shaw in Mogaung. Major Lumley with carbine under his arm. (MH 7287)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Major-General ‘Joe’ Lentaigne. (IND 3426)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Smoke rising after Stukas attack Leros. (HU 71385)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Members of 2 SAS who arrived in Termoli after the port had been captured by 1 SRS and numbers 3 and 40 (RM) Commando. (E 26182)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Ashley Greenwood dressed as a Turkish peasant after his escape from Leros. (HU 25273)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Corporal Horner after promotion to Sergeant. (SR 325)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("SB Squadron loading a caique before a raid in the Aegean. (E 29103)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Two SB Squadron soldiers preparing to land on the Simi raid. (E 29040)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Major the Earl Jellicoe, Captain Chevilier and a Greek officer on board the SB Squadron Headquarters boat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tewfik.")]), _vm._v(" (HU 71413)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("An "), _c('span', {
    attrs: {
      "href": "#/xhtml/35_Glossary#gloss50",
      "id": "rgloss50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MTB")]), _vm._v(" and caiques in a wooded cove in the Aegean. (HU 71403)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("MV "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Palma,")]), _vm._v(" one of the two vessels of the LRDG’s private navy in Bari. (HU 25268)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Johnnie Holmes and three other members of 1st SAS on Operation Bulbasket. Photographed in Le Forêt de Verrières near Châteauroux, June 1944. (HU 66209)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Sergeant Holdham, radio operator of Jedburgh Team Jude in the Colmar area of France, with three members of the French Resistance. (HU 62470)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("SB Squadron setting out for the raid on Santerine. (HU 71431)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Anders Lassen just before the Battle of Comacchio where he was killed winning a posthumous Victoria Cross. (HU 71361)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Three members of 2 SAS in Italy in 1945. (NA 25407)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("S Patrol: Popski’s Private Army on jeep patrol in the Apennines, Italy. (HU 1094)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("A jeep crew of Popski’s Private Army firing their armament. (HU 1114)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Lieutenant-Colonel V. Peniakoff "), _c('span', {
    attrs: {
      "href": "#/xhtml/35_Glossary#gloss20",
      "id": "rgloss20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DSO")]), _vm._v(" MC (‘Popski) driving his jeep in Italy at the end of the war. (HU 1122)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("SB Squadron in the Aegean, Anders Lassen in shorts, jersey and beret. (HU 71434).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Two LRDG soldiers, Gunner Jimmy Patch and Trooper Ron Hill, with a bearded Macedonian Partisan named Krsto. (HU 67339)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Motorized Submersible Canoe (MSC) or ‘Sleeping Beauty’. (HU 56756)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("MSC trimmed down underway in a test tank. (HU 56776)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("Captain Bob Page, Major Ivan Lyon and Lieutenant Donald Davidson. (HU 72130)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Operation Jaywick Team. (HU 72131)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da50da7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Illustrations.vue
// module id = 69
// module chunks = 0